// extracted by mini-css-extract-plugin
export default {"loginWrapper":"Login_loginWrapper__GpZe8","loginButtons":"Login_loginButtons__UO42w","buttonRecoveryPassword":"Login_buttonRecoveryPassword__79ZbG"};